import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { UserService } from 'app/core/user/user.service';
import { map, of, switchMap, take } from 'rxjs';

function getRoleDefaultRoute(role: string): string {
    switch (role) {
        case 'admin':
            return '/admin-management/admin-dashboard';
        case 'manager':
            return '/project-management';
        case 'hr':
            return '/employee-management/hr-dashboard';
        case 'finance':
            return '/finance-management/finance-dashboard';
        default:
            return '/sign-in';
    }
}

export function RoleGuard(...allowedRoles: string[]): CanActivateFn {
    return (route, state) => {
        const router: Router = inject(Router);
        const authService: AuthService = inject(AuthService);
        const userService: UserService = inject(UserService);

        return authService.check().pipe(
            switchMap((authenticated) => {
                if (!authenticated) {
                    const redirectURL = `redirectURL=${state.url}`;
                    return of(router.parseUrl(`sign-in?${redirectURL}`));
                }

                return userService.adminUserInfo$.pipe(
                    take(1),
                    map((userInfo) => {
                        const role = userInfo?.role?.toLowerCase() || '';
                        if (allowedRoles.includes(role)) {
                            return true;
                        }

                        console.warn(
                            `Access denied: ${state.url} requires [${allowedRoles.join(', ')}], user is '${role}'`
                        );
                        return router.parseUrl(getRoleDefaultRoute(role));
                    })
                );
            })
        );
    };
}
